// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"UserRole_modalBody__3Sdbu","buttonContainer":"UserRole_buttonContainer__VX83r","userEmail":"UserRole_userEmail__8AIeP"};